<template>
  <ValidationProvider
    :name="name"
    :rules="rules"
    v-slot="{ errors }"
    tag="div"
    class="country-selector"
  >
    <v-autocomplete
      v-bind="Object.assign({}, $attrs)"
      :search-input.sync="countryFilter"
      outline
      v-model="country"
      :items="countries"
      :item-text="itemText"
      :item-value="itemValue"
      :error-messages="errors"
      :name="country"
      :label="label || name"
    >
      <template v-slot:selection="data">
        <div>
          <v-avatar tile small contain size="24">
            <v-img
              :src="data.item.flag"
              lazy-src="/placeholder.jpg"
              :alt="data.item.cioc"
            />
          </v-avatar>

          {{ data.item.name }}
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item-avatar tile small contain size="24">
          <img :src="data.item.flag" :alt="data.item.cioc" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.name" />
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </ValidationProvider>
</template>

<script>
import Country from '@services/Countries';

export default {
  name: 'CountryField',
  props: {
    value: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Select Country',
    },
    rules: {
      type: String,
      default: '',
    },
    itemText: {
      type: String,
      default: 'name',
    },
    itemValue: {
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      countryFilter: '',
      country: this.value || '',
      countries: Country.get(),
    };
  },
  watch: {
    countryFilter(filter) {
      this.countries = Country.get(filter);
    },
    value(country) {
      this.country = country;
    },
    country(country) {
      this.$emit('input', country);
    },
  },
};
</script>

<style lang="scss">
.country-selector {
  .v-list__tile--link {
    padding-top: 2px !important;
  }
}
</style>
